import React from 'react'
import { takeMeToLoginPage } from '../../../functions/general';
import API_ENDPOINT from "../../../wm.api.service";
function ServerError({message,error}) {
  if(message !== 404) {
    if(error.response.data) return takeMeToLoginPage();
  }
  return (
    <>
        <div>
            <div className='text-center mt-10 space-y-2'>
                <span className='block manpro text-3xl'>{`${message} : An error has occured `}</span>
                <span className='block manpro text-base manpro '>Please wait for a while or refresh the page. </span>
                <span className='block manpro text-base manpro '>If this error still persists please contact us <a href={`${API_ENDPOINT.redirectURL}/legals/contactus`} className=' underline manpro text-base manpro text-blue-500'> here</a></span>
            </div>
        </div>
    </>
  )
}

export default ServerError